import {
  IDisplayBalance,
  IInternalBankingAccount,
  Query,
} from '@varo/graphql-schema-types';
import FetchRDCAccounts from 'services/graphql/queries/FetchRDCAccounts';
import { Maybe } from 'shared/utils/types';
import { AnyVariables, CombinedError, useQuery } from 'urql';

export interface RDCAccount extends IInternalBankingAccount, IDisplayBalance {}
interface AccountSelectorScreenState {
  isLoading: boolean;
  response?: RDCAccount[];
  error?: Maybe<CombinedError>;
  reload: () => void;
}

//Query that retrieves a list of RDC accounts that can be used for the check deposit flow.
export const useFetchAccountDetails = (): AccountSelectorScreenState => {
  const [
    {
      data: accountDetailsData,
      fetching: accountDetailsFetching,
      error: accountDetailsError,
    },
    refetchFetchDepositACheck,
  ] = useQuery<Query, AnyVariables>({
    query: FetchRDCAccounts,
    requestPolicy: 'cache-first',
  });

  const reload = (): void => {
    refetchFetchDepositACheck({ requestPolicy: 'network-only' });
  };

  return {
    isLoading: accountDetailsFetching,
    response: accountDetailsData?.myAccounts?.forRdc,
    error: accountDetailsError ?? null,
    reload,
  };
};
